<template>
  <div class="item" @click="detalhes()">
    <div class="col s8">
      <div class="info">
        <strong class="name">{{ produto.nome }}</strong>
        <p class="description">{{ produto.descricao }}</p>
        <p class="price" v-if="produto.valor != '0.00' ">R$ {{ produto.valor }}</p>
      </div>
    </div>
    <div class="col s4">
      <img v-if="produto.produto_imagem" class="responsive-img">
      <img v-else src="../../assets/no-image-1.jpg" class="responsive-img">
    </div>
  </div>
</template>

<script>
export default {
  name: "Item",
  props: ['produto'],
  methods: {
    detalhes() {
      this.$store.commit('produto', this.produto);
      this.$router.push('/' + this.$store.state.empresa_url + '/menu/produto/' + this.produto.id)
    }
  }
}
</script>

<style>
.item {
  width: 100%;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  cursor: pointer;
  padding: 26px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.03);
  background-color: #f9f9f9;
}

.item .info {
  width: 100%;
}

.item .info .name {
  display: block;
  margin-bottom: 8px;
  font-size: 17px;
  line-height: 20px;
}

.item .info .description {
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 17px;
  color: rgb(127, 143, 159);
}

.item .info .price {
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
}

@media only screen and (max-device-width: 768px) {
  .item {
    padding: 19px 5px 5px 5px;
    border: 1px solid rgba(0, 0, 0, 0.07);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/Item.vue